import { Tooltip, Typography, Box, ButtonBase } from '@mui/material'
import { useEffect, useState } from 'react'
import { BOOKMARKS_URL } from 'services/constants'
import { postRequest } from 'utils/api'
import RowStack from 'components/atoms/container/RowStack'
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined'
import BookmarkOutlinedIcon from '@mui/icons-material/BookmarkOutlined'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'

const BookmarkButton = ({
  bookmarked = false,
  stepContentId,
  onlyIcon = false
}) => {
  const { t } = useTranslation()
  const [marked, setMarked] = useState(bookmarked)
  const [contentId, setContentId] = useState(stepContentId)
  useEffect(() => {
    if (stepContentId !== contentId) {
      setMarked(bookmarked)
      setContentId(stepContentId)
    }
  }, [stepContentId, contentId, bookmarked])
  const toggleBookMark = async () => {
    const res = await postRequest(BOOKMARKS_URL, {
      goalStepContentId: stepContentId,
      bookmark: !marked
    })
    if (res.status === 200) {
      setMarked(!marked)
    }
  }

  const ToolTipWrapper = ({ children }) => {
    return (
      <Tooltip
        title={
          marked
            ? t('pathsAndModels.clickRemoveBookmark')
            : t('pathsAndModels.clickBookmarkContent')
        }>
        {children}
      </Tooltip>
    )
  }

  const BookMarkIcon = () => {
    const iconSx = {
      fontSize: onlyIcon ? 35 : 20,
      color: colors.MidnightTeal400
    }
    return (
      <ToolTipWrapper>
        {marked ? (
          <BookmarkOutlinedIcon sx={iconSx} />
        ) : (
          <BookmarkBorderOutlinedIcon sx={iconSx} />
        )}
      </ToolTipWrapper>
    )
  }

  const btnSx = {
    paddingX: 6,
    paddingY: 2,
    borderRadius: '0px 0px 8px 8px',
    border: `1px solid ${colors.Grey100}`,
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.08)',
    backgroundColor: colors.White
  }

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          zIndex: 1
        }}>
        <ButtonBase
          onClick={() => toggleBookMark()}
          sx={{
            position: 'absolute',
            right: 0,
            ...(!onlyIcon && btnSx)
          }}>
          <RowStack spacing={2}>
            {!onlyIcon && (
              <ToolTipWrapper>
                <Typography
                  variant='body1Small'
                  sx={{ fontWeight: 500, color: colors.MidnightTeal400 }}>
                  {t('bookmarks.bookmarkPage')}
                </Typography>
              </ToolTipWrapper>
            )}

            <BookMarkIcon />
          </RowStack>
        </ButtonBase>
      </Box>
    </>
  )
}

export default BookmarkButton
